import React from 'react';

import SpotlerSubscriptionForm from '../../../../components/Form/SpotlerSubscriptionForm';
import { GTM_SOURCE_MIJN_VNL } from '../../../../config/constants';

import './style.scss';


const EmailAccountPage: React.FC = () => (
  <SpotlerSubscriptionForm subscriptionSource={GTM_SOURCE_MIJN_VNL} />
);

export default EmailAccountPage;
